import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { IoInformationCircleOutline } from "react-icons/io5";
import Tooltip from "../../../../../../../Components/Tooltip/Tooltip";
import { useTranslation } from "react-i18next";

export default function AddressFormCard(props) {
  const { t } = useTranslation("products");
  const { StepCheck, SetStepCheck, Type, children } = props;

  const expanded = StepCheck["fullform"] === true;

  const handleform = () => {
    SetStepCheck((prevStepCheck) => ({
      ...prevStepCheck,
      fullform: !StepCheck["fullform"],
    }));
  };

  return (
    <section className="overflow-hidden rounded-lg border border-ui-border bg-ui-surface">
      <header className="flex items-center justify-between gap-3 border-b border-ui-border px-4 py-3">
        <div className="flex items-center gap-1.5">
          <h2 className="m-0 text-[13px] font-semibold uppercase tracking-[0.3px] text-ui-text">
            {Type === "Flist"
              ? t("addNew.address.pickup")
              : t("addNew.address.delivery")}
          </h2>

          <Tooltip
            title={
              Type === "Flist"
                ? t("addNew.address.from")
                : t("addNew.address.to")
            }
          >
            <IoInformationCircleOutline
              size={14}
              className="shrink-0 text-ui-text-subtle"
            />
          </Tooltip>
        </div>

        <button
          type="button"
          onClick={handleform}
          aria-expanded={expanded}
          className="flex items-center gap-1 rounded-md border border-ui-border px-2 py-1 text-[11px] font-medium text-ui-text-muted transition-colors hover:border-brand hover:text-brand"
        >
          {expanded ? t("addNew.address.collapse") : t("addNew.address.expand")}
          {expanded ? (
            <MdOutlineKeyboardArrowUp size={14} />
          ) : (
            <MdOutlineKeyboardArrowDown size={14} />
          )}
        </button>
      </header>

      <div className="p-4">{children}</div>
    </section>
  );
}
